// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"ad069af3","339":"aee2c1ea","453":"82b45f7b","924":"42fdaaeb"}[chunkId] + ".chunk.js";
};